// JS inline imports
import '@hotwired/turbo-rails'

// styles imports
import 'styles/site'

// JS async imports
import('src/fontawesome')
import('src/service_worker')
